module.exports = __webpack_public_path__ + "img/Imovel_Certo@2x.02f74bde.png";